export default __webpack_public_path__ + "static/media/paper-fireworks.0164ad7f.svg";